
export default function isElement (element) {
  return typeof HTMLElement !== 'undefined'
    ? element instanceof HTMLElement
    : element !== null && typeof element === 'object' && element.nodeType === 1 && typeof element.nodeName === 'string';
}
